
import { Component, Prop, Vue } from 'vue-property-decorator';
import Breadcrumb from '@/components/BreadCrumb.vue';

@Component({
  components: {
    Breadcrumb,
  },
})
export default class RouteTitle extends Vue {
  @Prop(String) private label?: string;
  @Prop({ type: Boolean, default: false }) private gradient!: boolean;

  get currentRouteLabel(): string {
    return this.$route.meta && this.$route.meta.labels
      ? this.$route.meta.labels.join(' ')
      : '';
  }

  get pageLabel(): string {
    return this.label || this.currentRouteLabel;
  }
}
